/**
 * Общая логика аккордеонов: главная, детсад, начальная/средняя/старшая школа.
 * ES-модуль; отдельная сборка в IIFE — window.UnifiedAccordion (rollup-unified-accordion.config.js).
 */

export function scrollAccordionHeaderIntoView(header, snapshot, options) {
  if (!header) return;

  options = options || {};
  var transitionMs = typeof options.transitionMs === "number" ? options.transitionMs : 450;
  var finalDelay = transitionMs + 50;
  var earlyDelays =
    transitionMs >= 800
      ? [0, 16, 32, 50, 100, 150, 200, 400, 600, 750]
      : [0, 16, 32, 50, 100, 150];

  var scrollY = snapshot && typeof snapshot.scrollY === "number" ? snapshot.scrollY : window.scrollY;
  var scrollX = snapshot && typeof snapshot.scrollX === "number" ? snapshot.scrollX : window.scrollX;
  var headerTopBefore =
    snapshot && typeof snapshot.headerDocTopBefore === "number"
      ? snapshot.headerDocTopBefore
      : header.getBoundingClientRect().top + scrollY;

  function compensateOnly() {
    var headerTopAfter = header.getBoundingClientRect().top + window.scrollY;
    var shiftUp = headerTopBefore - headerTopAfter;
    var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var compensated = Math.max(0, Math.min(scrollY - shiftUp, maxScroll));
    if (Math.abs(window.scrollY - compensated) > 1) {
      window.scrollTo({ top: compensated, left: scrollX, behavior: "auto" });
    }
  }

  function pinHeaderUnderNav() {
    var maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var topBar = document.querySelector(".top_bar");
    var navBar = document.querySelector(".nav-bar");
    var offset = (topBar ? topBar.offsetHeight : 0) + (navBar ? navBar.offsetHeight : 0) + 16;
    var rect = header.getBoundingClientRect();
    var top = window.pageYOffset + rect.top - offset;
    window.scrollTo({ top: Math.max(0, Math.min(top, maxScroll)), behavior: "smooth" });
  }

  var html = document.documentElement;
  var prevHtmlBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = "auto";

  earlyDelays.forEach(function(d) {
    setTimeout(function() {
      requestAnimationFrame(compensateOnly);
    }, d);
  });

  setTimeout(function() {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        compensateOnly();
        pinHeaderUnderNav();
        html.style.scrollBehavior = prevHtmlBehavior;
      });
    });
  }, finalDelay);
}

function skipInternalSecondaryHeader(header) {
  return (
    header.closest("[data-secondary-admission-accordion]") ||
    header.closest("[data-secondary-alumni-accordion]")
  );
}

/**
 * Главная landing: глобальные .accordion_header / .accordion_content, +/× в span:last-child
 */
export function initLandingAccordionHeaders() {
  document.querySelectorAll(".accordion_header").forEach(function(header) {
    if (skipInternalSecondaryHeader(header)) return;

    header.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      var content = header.nextElementSibling;
      if (!content) return;

      var isOpen = content.classList.contains("open");
      var span = header.querySelector("span:last-child");

      var scrollY = window.scrollY;
      var scrollX = window.scrollX;

      var html = document.documentElement;
      var body = document.body;
      var originalScrollBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto";
      body.style.scrollBehavior = "auto";

      document.querySelectorAll(".accordion_content").forEach(function(item) {
        item.classList.remove("open");
      });
      document.querySelectorAll(".accordion_header").forEach(function(h) {
        h.classList.remove("active");
        var s = h.querySelector("span:last-child");
        if (s) {
          s.textContent = "+";
          s.classList.remove("close_x");
        }
      });

      if (!isOpen) {
        content.classList.add("open");
        header.classList.add("active");
        if (span) {
          if (header === document.querySelector(".accordion_header.active")) {
            span.textContent = "×";
            span.classList.add("close_x");
          } else {
            span.textContent = "−";
          }
        }
      }

      var headerDocTopBefore = header.getBoundingClientRect().top + scrollY;

      setTimeout(function() {
        html.style.scrollBehavior = originalScrollBehavior;
        body.style.scrollBehavior = "";
      }, 850);

      if (!isOpen) {
        scrollAccordionHeaderIntoView(
          header,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 800 }
        );
      }
    });
  });
}

/** Block17 на главной (landing faq) — без data-secondary-faq */
export function initLandingBlock17Accordion() {
  document.querySelectorAll(".block17_accordion_header").forEach(function(header) {
    if (header.closest("[data-secondary-faq]")) return;

    header.addEventListener("click", function() {
      var content = header.nextElementSibling;
      if (!content) return;
      var isOpen = content.classList.contains("open");

      document.querySelectorAll(".block17_accordion_content").forEach(function(item) {
        item.classList.remove("open");
      });
      document.querySelectorAll(".block17_accordion_header").forEach(function(h) {
        h.classList.remove("active");
      });

      if (!isOpen) {
        content.classList.add("open");
        header.classList.add("active");
        var scrollY = window.scrollY;
        var scrollX = window.scrollX;
        var headerDocTopBefore = header.getBoundingClientRect().top + scrollY;
        scrollAccordionHeaderIntoView(
          header,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 400 }
        );
      }
    });
  });
}

export function initLandingPageAccordions() {
  initLandingAccordionHeaders();
  initLandingBlock17Accordion();
}

/**
 * Детсад: блок «Как проходит обучение» + кнопки из FAQ (расписание / меню)
 */
export function initKindergartenLearningAccordion() {
  var section = document.getElementById("learning-process");
  var root = section || document;

  root.querySelectorAll(".kindergarten-learning-process-accordion-header").forEach(function(header) {
    header.addEventListener("click", function() {
      var content = header.nextElementSibling;
      if (!content) return;
      var isOpen = content.classList.contains("open");

      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      var headerDocTopBefore = header.getBoundingClientRect().top + scrollY;

      document.querySelectorAll(".kindergarten-learning-process-accordion-content").forEach(function(item) {
        item.classList.remove("open");
      });
      document.querySelectorAll(".kindergarten-learning-process-accordion-header").forEach(function(h) {
        h.classList.remove("active");
      });

      if (!isOpen) {
        content.classList.add("open");
        header.classList.add("active");
        scrollAccordionHeaderIntoView(
          header,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 450 }
        );
      }
    });
  });

  function openKindergartenAccordionByTitle(titleText) {
    var scheduleHeader = null;
    document.querySelectorAll(".kindergarten-learning-process-accordion-header").forEach(function(header) {
      var info = header.querySelector(".kindergarten-learning-process-accordion-info");
      if (info && info.textContent.trim() === titleText) {
        scheduleHeader = header;
      }
    });
    if (!scheduleHeader) return;
    document.querySelectorAll(".kindergarten-learning-process-accordion-content").forEach(function(item) {
      item.classList.remove("open");
    });
    document.querySelectorAll(".kindergarten-learning-process-accordion-header").forEach(function(h) {
      h.classList.remove("active");
    });
    var scheduleContent = scheduleHeader.nextElementSibling;
    if (scheduleContent) {
      scheduleContent.classList.add("open");
      scheduleHeader.classList.add("active");
    }
  }

  var scheduleButton = document.querySelector(".block17_schedule_button");
  if (scheduleButton) {
    scheduleButton.addEventListener("click", function(e) {
      e.preventDefault();
      var learningProcessSection = document.getElementById("learning-process");
      if (!learningProcessSection) return;
      openKindergartenAccordionByTitle("График занятий");
      var headerHeight = document.querySelector(".nav-bar") ? document.querySelector(".nav-bar").offsetHeight : 0;
      var topBarHeight = document.querySelector(".top_bar") ? document.querySelector(".top_bar").offsetHeight : 0;
      var offset = headerHeight + topBarHeight + 20;
      var targetPosition = learningProcessSection.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    });
  }

  var menuButton = document.querySelector(".block17_menu_button");
  if (menuButton) {
    menuButton.addEventListener("click", function(e) {
      e.preventDefault();
      var learningProcessSection = document.getElementById("learning-process");
      if (!learningProcessSection) return;
      openKindergartenAccordionByTitle("Меню детского сада");
      var headerHeight = document.querySelector(".nav-bar") ? document.querySelector(".nav-bar").offsetHeight : 0;
      var topBarHeight = document.querySelector(".top_bar") ? document.querySelector(".top_bar").offsetHeight : 0;
      var offset = headerHeight + topBarHeight + 20;
      var targetPosition = learningProcessSection.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: targetPosition, behavior: "smooth" });
    });
  }
}

export function initMiddleHighLearningProcess() {
  document.querySelectorAll(".middle-high-learning-process-accordion-item").forEach(function(item) {
    var header = item.querySelector(".middle-high-learning-process-accordion-header");
    var content = item.querySelector(".middle-high-learning-process-accordion-content");
    if (!header || !content) return;

    var setExpanded = function(expanded) {
      header.setAttribute("aria-expanded", expanded ? "true" : "false");
      header.classList.toggle("active", expanded);
      content.classList.toggle("open", expanded);
    };

    setExpanded(false);

    header.addEventListener("click", function() {
      var shouldOpen = !header.classList.contains("active");
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      var headerDocTopBefore = header.getBoundingClientRect().top + scrollY;
      var learningRoot = item.closest(".middle-high-learning-process");
      var siblings = learningRoot
        ? learningRoot.querySelectorAll(".middle-high-learning-process-accordion-item")
        : [];

      siblings.forEach(function(entry) {
        var entryHeader = entry.querySelector(".middle-high-learning-process-accordion-header");
        var entryContent = entry.querySelector(".middle-high-learning-process-accordion-content");
        if (!entryHeader || !entryContent) return;

        entryHeader.setAttribute("aria-expanded", "false");
        entryHeader.classList.remove("active");
        entryContent.classList.remove("open");
      });

      setExpanded(shouldOpen);
      if (shouldOpen) {
        scrollAccordionHeaderIntoView(
          header,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 450 }
        );
      }
    });
  });
}

export function initMiddleHighAdmission() {
  var section = document.querySelector("[data-secondary-admission-accordion]");
  if (!section || section.dataset.secondaryAdmissionAccordionBound === "1") return;

  var items = Array.prototype.slice.call(section.querySelectorAll(".accordion_item"));
  if (!items.length) return;

  section.dataset.secondaryAdmissionAccordionBound = "1";

  function setOpen(item, isOpen) {
    var header = item.querySelector(".accordion_header");
    var content = item.querySelector(".accordion_content");
    if (!header || !content) return;

    header.classList.toggle("active", isOpen);
    content.classList.toggle("open", isOpen);
    header.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  items.forEach(function(item) {
    setOpen(item, false);
    var header = item.querySelector(".accordion_header");
    if (header) {
      header.setAttribute("role", "button");
      header.setAttribute("tabindex", "0");
      header.setAttribute("aria-expanded", "false");
    }
  });

  section.addEventListener(
    "click",
    function(e) {
      var header = e.target.closest(".accordion_header");
      if (!header || !section.contains(header)) return;
      var item = header.closest(".accordion_item");
      if (!item || !section.contains(item)) return;

      var shouldOpen = !header.classList.contains("active");
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      var headerDocTopBefore = header.getBoundingClientRect().top + scrollY;
      items.forEach(function(entry) {
        setOpen(entry, false);
      });
      setOpen(item, shouldOpen);
      if (shouldOpen) {
        scrollAccordionHeaderIntoView(
          header,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 800 }
        );
      }
    },
    true
  );

  section.addEventListener(
    "keydown",
    function(e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var header = e.target.closest(".accordion_header");
      if (!header || !section.contains(header)) return;
      e.preventDefault();
      header.click();
    },
    true
  );
}

export function initMiddleHighAlumni() {
  var section = document.querySelector("[data-secondary-alumni-accordion]");
  if (!section || section.dataset.secondaryAlumniAccordionBound === "1") return;

  section.dataset.secondaryAlumniAccordionBound = "1";

  section.querySelectorAll(".alumni_accordion_item").forEach(function(item) {
    var header = item.querySelector(".accordion_header");
    var content = item.querySelector(".accordion_content");
    if (!header || !content) return;

    function setOpen(isOpen) {
      header.classList.toggle("active", isOpen);
      content.classList.toggle("open", isOpen);
    }

    setOpen(false);

    header.addEventListener("click", function() {
      var shouldOpen = !header.classList.contains("active");
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      var headerDocTopBefore = header.getBoundingClientRect().top + scrollY;

      section.querySelectorAll(".alumni_accordion_item").forEach(function(entry) {
        var entryHeader = entry.querySelector(".accordion_header");
        var entryContent = entry.querySelector(".accordion_content");
        if (!entryHeader || !entryContent) return;

        entryHeader.classList.remove("active");
        entryContent.classList.remove("open");
      });

      setOpen(shouldOpen);
      if (shouldOpen) {
        scrollAccordionHeaderIntoView(
          header,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 800 }
        );
      }
    });
  });
}

export function initMiddleHighFaq() {
  var section = document.querySelector("[data-secondary-faq]");
  if (!section) return;

  var items = Array.from(section.querySelectorAll(".block17_accordion_item"));

  function setOpen(item, isOpen) {
    var header = item.querySelector(".block17_accordion_header");
    var content = item.querySelector(".block17_accordion_content");
    if (!header || !content) return;

    header.setAttribute("aria-expanded", isOpen ? "true" : "false");
    header.classList.toggle("active", isOpen);
    content.classList.toggle("open", isOpen);
  }

  items.forEach(function(item) {
    var header = item.querySelector(".block17_accordion_header");
    if (!header) return;

    setOpen(item, false);

    function toggleFaqItem() {
      var targetHeader = item.querySelector(".block17_accordion_header");
      if (!targetHeader) return;

      var wasOpen = targetHeader.getAttribute("aria-expanded") === "true";
      var scrollY = window.scrollY;
      var scrollX = window.scrollX;
      var headerDocTopBefore = targetHeader.getBoundingClientRect().top + scrollY;
      items.forEach(function(entry) {
        setOpen(entry, false);
      });

      if (!wasOpen) {
        setOpen(item, true);
        scrollAccordionHeaderIntoView(
          targetHeader,
          { scrollY: scrollY, scrollX: scrollX, headerDocTopBefore: headerDocTopBefore },
          { transitionMs: 450 }
        );
      }
    }

    header.addEventListener("click", toggleFaqItem);
    header.addEventListener("keydown", function(event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggleFaqItem();
      }
    });
  });
}

export function initMiddleHighSchoolAccordions() {
  initMiddleHighAdmission();
  initMiddleHighLearningProcess();
  initMiddleHighAlumni();
  initMiddleHighFaq();
}
